import { x } from '@xstyled/styled-components';

import { FAMILY } from '../data';
import { FamilyMemberId } from '../engine';

type Props = {
  memberId: FamilyMemberId;
  sizePx?: number;
};

/** blueprint-style initial badge — the family's faces stay line art, like the house */
export const FamilyAvatar = ({ memberId, sizePx = 28 }: Props) => (
  <x.span
    alignItems="center"
    aria-hidden
    border="1px solid"
    borderColor="uiHeadingCopy"
    borderRadius={999}
    color="uiHeadingCopy"
    display="inline-flex"
    flex="none"
    fontSize={`${Math.round(sizePx * 0.45)}px`}
    fontWeight="bold"
    h={`${sizePx}px`}
    justifyContent="center"
    w={`${sizePx}px`}
  >
    {FAMILY[memberId].initial}
  </x.span>
);
